import { DateTime } from 'luxon';
import { TimeRange } from '../../../src/types';
/* eslint-disable @typescript-eslint/no-explicit-any */
export interface SuperdayInterviewerLinkSettings {
    minAvailabilityMinutes: number;
    maxUpdateWindowHours: number;
}

export interface InterviewerLink {
    id: string;
    organizationId: string;
    superdayId: string;
    settings: SuperdayInterviewerLinkSettings;
    url: string;
    customUrl?: string;
}

export interface InterviewBlock {
    id?: string;
    desiredOrder: number;
    startTime: string;
    endTime: string;
    superdayId: string;
    organizationId: string;
}

export interface InterviewerLinkIntroResponse {
    blocks: InterviewBlock[];
    superdayInterviewerLink: InterviewerLink;
    eventDuration: number;
}

export interface InterviewerLinkIntroData {
    organizationSlug: string;
    customUrl: string;
}

export interface EmailValidationData {
    email: string;
    id: string;
}

export interface RemovedGroup {
    blockStartTime: string;
    interviewGroupIndex: number;
    interviewTimeBlockIndex: number;
    iteration: number;
    interviewBlockStartTime?: string;
}
export interface EmailValidationResponse {
    interviewerLink: InterviewerLink;
    interviewerEventBlockSlots: any;
    removedGroups: RemovedGroup[];
    interviewer: any;
    eventDuration: number;
}

export interface LinkAvailabilityData {
    interviewerLink: InterviewerLink;
    interviewerEventBlockSlots: any;
    removedGroups: RemovedGroup[];
    interviewer: any;
    eventDuration?: number;
    completed?: boolean;
}

export enum InterviewerToEventBlockSlotStatus {
    FREE = 'free',
    USED = 'used',
    CANCELED = 'canceled',
}

export interface InterviewerEventBlockSlotDto {
    etchUserId: string;
    eventId?: string;
    eventDesiredOrder: number;
    superdayId?: string;
    startTime: string;
    endTime: string;
    status: InterviewerToEventBlockSlotStatus;
}

export interface UpdateInterviewerAvailabilityData {
    interviewerLinkId: string;
    etchUserId: string;
    interviewerEventBlockSlots: InterviewerEventBlockSlotDto[];
    removedGroups: RemovedGroup[];
}

export interface InterviewerAvailabilityData {
    timeRanges: TimeRange[];
}
export interface InterviewBlockEntity {
    id?: string;
    superdayId?: string;
    startTime: string;
    endTime: string;
    desiredOrder: number;
    organizationId?: string;
    createdAt?: string;
    updatedAt?: string;
    freeInterviewerBlockSlotsCount?: number;
    usedInterviewerBlockSlotsCount?: number;
}

interface TimeOption {
    label: string;
    value: DateTime;
}
export interface BlockDisplayItem {
    block: InterviewBlock;
    blockIndex: number;
    timeOptions?: TimeOption[];
}

export interface BlockDisplayEntity {
    dateHeader: string;
    times: BlockDisplayItem[];
}
